import React from "react";
import { Divider, Grid, Typography, Box } from "@mui/material";
import { InputField } from "../../../../utils/FormFields";
import PhoneField from "../../../../utils/FormFields/PhoneField";
import { FileBodyTypeEnum } from "../../../../api/file-management";
import UploadField from "../../../../utils/FormFields/UploadField";

export default function EditPatientAccount(props: any) {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Account Details
      </Typography>
      <Divider />
      <Grid rowSpacing={3} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Contact.PrimaryEmail.Email" label="Email" fullWidth />
          </Box>       
        </Grid>
        <Grid container />

        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Contact.SecondaryEmail.Email" label="Secondary Email" fullWidth />
          </Box>
        </Grid>
        <Grid container />

        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <PhoneField
              name="User.Contact.PrimaryPhone.Phone"
              label="Phone Number"
              fieldName="User.Contact.PrimaryPhone.CountryCode"
            />
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={3} sx={{ mt: 2 }}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <PhoneField
              name="User.Contact.SecondaryPhone.Phone"
              label="Second Number"
              fieldName="User.Contact.SecondaryPhone.CountryCode"
            />
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <UploadField name="User.PhotoURI" label="Photo" fullWidth fileType={FileBodyTypeEnum.PROFILEPICTURE} />
          </Box>        
        </Grid>
      </Grid>
    </>
  );
}
